import React from "react";
import {
  Box,
  Card,
  Grid,
  Skeleton,
  Stack,
  Divider,
} from "@mui/material";

export default function PaymentPlansSkeleton() {
  return (
    <Box sx={{ width: "100%" }}>
      {/* ================= SUMMARY CARDS ================= */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[1, 2, 3].map((_, index) => (
          <Grid  xs={12} md={4} key={index}>
            <Card sx={{ p: 3 }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Skeleton variant="circular" width={48} height={48} />
                <Box flexGrow={1}>
                  <Skeleton width="60%" height={20} />
                  <Skeleton width="40%" height={28} />
                </Box>
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ================= PAGE HEADER ================= */}
      <Box sx={{ mb: 4 }}>
        <Skeleton width={220} height={36} />
        <Skeleton width={420} height={22} />
      </Box>

      {/* ================= PLAN CARD ================= */}
      <Card sx={{ p: 3 }}>
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 3 }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Skeleton variant="circular" width={14} height={14} />
            <Box>
              <Skeleton width={160} height={22} />
              <Skeleton width={120} height={18} />
            </Box>
          </Stack>

          <Skeleton variant="circular" width={32} height={32} />
        </Stack>

        {/* Progress */}
        <Box sx={{ mb: 3 }}>
          <Stack direction="row" justifyContent="space-between">
            <Skeleton width={180} height={18} />
            <Skeleton width={60} height={18} />
          </Stack>

          <Skeleton
            variant="rectangular"
            height={10}
            sx={{ borderRadius: 5, mt: 1 }}
          />

          <Stack direction="row" justifyContent="space-between" sx={{ mt: 1 }}>
            <Skeleton width={160} height={16} />
            <Skeleton width={100} height={16} />
          </Stack>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* ================= SCHEDULE TABLE ================= */}
        <Box>
          <Skeleton width={180} height={24} sx={{ mb: 2 }} />

          {/* Table Header */}
          <Grid container spacing={2} sx={{ mb: 1 }}>
            {[1, 2, 3, 4].map((_, i) => (
              <Grid  xs={3} key={i}>
                <Skeleton height={20} />
              </Grid>
            ))}
          </Grid>

          {/* Table Rows */}
          {[1, 2, 3, 4].map((_, index) => (
            <Grid
              container
              spacing={2}
              alignItems="center"
              key={index}
              sx={{ mb: 1 }}
            >
              <Grid  xs={3}>
                <Skeleton height={18} />
              </Grid>
              <Grid  xs={3}>
                <Skeleton height={18} />
              </Grid>
              <Grid  xs={3}>
                <Skeleton width={80} height={22} />
              </Grid>
              <Grid  xs={3}>
                <Skeleton width={24} height={24} />
              </Grid>
            </Grid>
          ))}
        </Box>
      </Card>
    </Box>
  );
}
